/* eslint-disable quotes */

// Source: https://stackoverflow.com/a/51093815
export function trackMouseUsage() {
    // Let the document know when the mouse is being used
    document.body.addEventListener("mousedown", () => {
        document.body.classList.add("using-mouse");
    });

    // Re-enable focus styling when Tab is pressed
    document.body.addEventListener("keydown", (event) => {
        if (event.key === "Tab") {
            document.body.classList.remove("using-mouse");
        }
    });
}
